export default __webpack_public_path__ + "static/media/hardening-icon-dark.a84fff30.svg";